<template>
  <IconWithCaption
    v-if="props.label !== DrawLabel.None"
    :caption="$t(`lottery.draw.label.${label}`)"
    :icon="iconName"
  />
</template>

<script lang="ts" setup>
import { DrawLabel } from '#api/shared/@types/generated/backend/graphql-schema-types'

type IconNameValues = 'day-afternoon' | 'day-evening' | 'day-midday' | 'day-morning'

type LotteryDrawLabelProps = {
  label: DrawLabel
}

const props = defineProps<LotteryDrawLabelProps>()

const ICON_MAP: Partial<Record<DrawLabel, IconNameValues>> = {
  [DrawLabel.Afternoon]: 'day-afternoon',
  [DrawLabel.Evening]: 'day-evening',
  [DrawLabel.Midday]: 'day-midday',
  [DrawLabel.Morning]: 'day-morning',
  [DrawLabel.Night]: 'day-evening',
}

const iconName = computed(() => ICON_MAP[props.label] ?? 'day-midday')
</script>
